import React from 'react';
import { Card, CardContent, CardHeader, Avatar, Button, Grid } from '@mui/material';
import { useAuth } from '../../context/AuthContext';
import Sidebar from '../Sidebar/Sidebar';
import { jwtDecode } from 'jwt-decode';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import EmailIcon from '@mui/icons-material/Email';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import LogoutIcon from '@mui/icons-material/Logout';
import './Account.css';

const Account: React.FC = () => {
    const { token, logout } = useAuth();

    // Decode the token to get user information (assuming token contains username and email)
    const decodedToken = token ? jwtDecode<{ username: string, email: string, 'custom:roles': string, 'cognito:username': string  }>(token) : null;
    const username = decodedToken?.['cognito:username'] || 'Unknown';
    const email = decodedToken?.email || 'Unknown';
    const roles = decodedToken?.['custom:roles'] || 'user';

    return (
        <div>
            <Sidebar />
            <Grid container justifyContent="center" sx={{ marginTop: 4 }}>
                <Card sx={{ maxWidth: 600, width: '100%' }}>
                    <CardHeader
                        avatar={
                            <Avatar sx={{ bgcolor: 'primary.main' }}>
                                <AccountCircleIcon />
                            </Avatar>
                        }
                        subheader={<h2>Account Information</h2>}
                    />
                    <CardContent>
                        <Grid container spacing={2} alignItems="center">
                            <Grid item>
                                <AccountCircleIcon sx={{ color: 'secondary.main' }} />
                            </Grid>
                            <Grid item>
                                <span>Username: {username}</span>
                            </Grid>
                        </Grid>
                        <Grid container spacing={2} alignItems="center">
                            <Grid item>
                                <EmailIcon sx={{ color: 'secondary.main' }} />
                            </Grid>
                            <Grid item>
                                <span>Email: {email}</span>
                            </Grid>
                        </Grid>
                        <Grid container spacing={2} alignItems="center">
                            <Grid item>
                                <VerifiedUserIcon sx={{ color: 'secondary.main' }} />
                            </Grid>
                            <Grid item>
                                <span>Roles: {roles}</span>
                            </Grid>
                        </Grid>
                        <Grid container justifyContent="flex-end" sx={{ marginTop: 2 }}>
                            <Button
                                variant="contained"
                                sx={{ backgroundColor: 'primary.light' }}
                                startIcon={<LogoutIcon sx={{ color: 'primary.contrastText' }} />}
                                onClick={logout}
                            >
                                Logout
                            </Button>
                        </Grid>
                    </CardContent>
                </Card>
            </Grid>
        </div>
    );
};

export default Account;
